import type { Components } from 'react-markdown';

/**
 * Полный GFM-markdown для ответов агента (как в ChatGPT): блочная вёрстка,
 * таблицы, цитаты, заголовки, задачи. Не использовать вместе с float-метой в одной строке.
 */
export const MESSENGER_MARKDOWN_AGENT_FULL_COMPONENTS: Partial<Components> = {
  a: ({ href, children, ...rest }) => (
    <a {...rest} href={href ?? '#'} target="_blank" rel="noreferrer noopener">
      {children}
    </a>
  ),
  h1: ({ children }) => <h1 className="messengerAgentMd__h messengerAgentMd__h1">{children}</h1>,
  h2: ({ children }) => <h2 className="messengerAgentMd__h messengerAgentMd__h2">{children}</h2>,
  h3: ({ children }) => <h3 className="messengerAgentMd__h messengerAgentMd__h3">{children}</h3>,
  h4: ({ children }) => <h4 className="messengerAgentMd__h messengerAgentMd__h4">{children}</h4>,
  h5: ({ children }) => <h5 className="messengerAgentMd__h messengerAgentMd__h5">{children}</h5>,
  h6: ({ children }) => <h6 className="messengerAgentMd__h messengerAgentMd__h6">{children}</h6>,
  blockquote: ({ children }) => (
    <blockquote className="messengerAgentMd__blockquote">{children}</blockquote>
  ),
  hr: () => <hr className="messengerAgentMd__hr" />,
  table: ({ children }) => (
    <div className="messengerAgentMd__tableWrap">
      <table className="messengerAgentMd__table">{children}</table>
    </div>
  ),
  img: ({ src, alt, title, ...rest }) => {
    if (!src || typeof src !== 'string') return null;
    return (
      <img
        {...rest}
        src={src}
        alt={alt ?? ''}
        title={title}
        className="messengerAgentMd__img"
        loading="lazy"
        decoding="async"
      />
    );
  },
  input: ({ type, checked, node: _node, ...rest }) => {
    if (type === 'checkbox') {
      return (
        <input
          {...rest}
          type="checkbox"
          checked={Boolean(checked)}
          disabled
          readOnly
          tabIndex={-1}
          className="messengerAgentMd__taskCheckbox"
          aria-hidden
        />
      );
    }
    return null;
  },
};
